import { Component, Input } from '@angular/core';

@Component({
    selector: 'pr-toolbar',
    templateUrl: './pr-toolbar.component.html',
    styleUrls: ['./pr-toolbar.component.scss'],
    standalone: false
})
export class PrToolbarComponent {
  @Input() clazz: string;
  constructor() {}
}
